.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  background-color: transparent;
  background-image: url(/images/default-background.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 100%;
  min-height: 20rem;

  @media screen and (min-width: $bp-medium) {
    gap: 2.4rem;
    min-height: 32rem;
  }
}

.description {
  max-width: 34rem;
  font-weight: 400;
  line-height: 1.6rem;
  text-align: center;
  color: var(--color-grayscale-anti-flash-white);
}

.action-container {
  max-width: 18rem;
  width: 100%;

  @media screen and (max-width: #{$bp-medium + 1}) {
    display: flex;
    justify-content: center;

    & > button[data-full='true'] {
      width: fit-content;
      height: 3.2rem;
    }
  }
}
